import React from 'react';
import { useParams } from 'react-router-dom';
import usePeopleService, { Person } from '../peopleService';
import DataLoader from '../../shared/DataLoader';
import SinglePersonPage from '../shared/SinglePersonPage';
import HistoryEventsList from '../shared/HistoryEventsList';
import usePeopleHistoryService from './peopleHistoryService';
import OpenShowProfilePageButton from '../Update/OpenShowProfilePageButton';
import { PersonBreadcrumbs } from '../Update/PersonUpdatePage';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';

function PersonHistoryBreadcrumbs(
  props: {
    person: Person,
  },
) {
  return (
    <PersonBreadcrumbs person={props.person}>
      <Breadcrumb text="History" />
    </PersonBreadcrumbs>
  );
}

export default function PersonHistoryPage() {
  const peopleService = usePeopleService();
  const peopleHistoryService = usePeopleHistoryService();

  const params = useParams<{ id: string }>();

  const id = params.id as unknown as number;

  return (
    <DataLoader<Person> getDataFunc={async () => peopleService.getById(id)}>
      {(person) => {
        return (
          <>
            <PersonHistoryBreadcrumbs person={person} />
            <SinglePersonPage
              headerRight={<OpenShowProfilePageButton person={person} />}
              person={person}
            >
              <HistoryEventsList
                getEventsFunc={
                  (filter, nextPageToken) => peopleHistoryService.getHistoryEvents(
                    person.id,
                    filter,
                    nextPageToken as number,
                  )
                }
              />
            </SinglePersonPage>
          </>
        );
      }}
    </DataLoader>
  );
}
